import { render, staticRenderFns } from "./PrivacyPolicyJA.vue?vue&type=template&id=3299ea4c&scoped=true"
import script from "./PrivacyPolicyJA.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyJA.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyJA.vue?vue&type=style&index=0&id=3299ea4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3299ea4c",
  null
  
)

export default component.exports